import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TypeRampV2 } from "../../../typography";
export var SelectedOptionFacade = styled(TypeRampV2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: 18px;\n    min-width: 0;\n    overflow-wrap: break-word;\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return menuTheme.fontSize(themeMode);
});
//# sourceMappingURL=SelectedOptionFacade.js.map